import { render, staticRenderFns } from "./tasting_juror_card.vue?vue&type=template&id=04fb6fad&scoped=true"
import script from "./tasting_juror_card.vue?vue&type=script&lang=js"
export * from "./tasting_juror_card.vue?vue&type=script&lang=js"
import style0 from "./tasting_juror_card.vue?vue&type=style&index=0&id=04fb6fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fb6fad",
  null
  
)

export default component.exports